import { Icon } from '@aibees/shared/components';
import { SHARED_ROUTES as R } from '@aibees/shared/constants/routes';
import { useAddCardMutationApi } from '@aibees/shared/features/billing-profile/api/use-add-card-mutation-api';
import { classnames } from '@aibees/shared/utils';
import { Button, CardHeader, Stack, Typography } from '@mui/material';
import { memo } from 'react';
import { AddCardFailed } from './components/add-card-failed';
import { AddCardSuccess } from './components/add-card-success';
import type { PaymentMethodHeaderProps as Props } from './types';

export const PaymentMethodHeader = memo(({ className }: Props) => {
  const { mutateAsync } = useAddCardMutationApi();

  const handleAddCard = () => {
    mutateAsync({
      redirect: {
        success: `${window.origin + R.billing}#${'successAddCard'}`,
        failed: `${window.origin + R.billing}#${'failedAddCard'}`,
      },
    });
  };
  return (
    <>
      <CardHeader
        className={classnames('PaymentMethodHeader', className)}
        title={
          <Stack>
            <Typography variant="body3" fontWeight={700} color="grey.700">
              Manage your payment method for Billing
            </Typography>
          </Stack>
        }
        action={
          <Button
            variant="contained"
            size="xsmall"
            color="primary"
            startIcon={<Icon name="plus" size={20} />}
            onClick={handleAddCard}
          >
            Add Payment Card
          </Button>
        }
      />
      <AddCardSuccess />
      <AddCardFailed />
    </>
  );
});

PaymentMethodHeader.displayName = 'PaymentMethodHeader';
